import React, { useEffect } from 'react'
import Header from './Header'
// import ParticlesFooterBackground from './ParticlesFooter'
// import Footer from './Footer'
import 'quill/dist/quill.core.css';
import FAQs from '../home/FAQs';
const ParticlesFooterBackground = React.lazy(() => import("./ParticlesFooter"));
const Footer = React.lazy(() => import("./Footer"));

const Layout = (props) => {

  const location = window.location.pathname;
  const faqData = props?.pageContext?.faqData;

  // Tawk.to Chatbot
  useEffect(() => {
    if (location.startsWith("/admin")) {
      return;
    }

    // Already loaded - don't load it again during Gatsby navigation.
    if (document.getElementById("tawk-script")) {
      return;
    }

    let fallbackTimer;

    const loadTawk = () => {
      if (document.getElementById("tawk-script")) {
        return;
      }

      const script = document.createElement("script");

      script.id = "tawk-script";
      script.async = true;
      script.src = "https://embed.tawk.to/69298d920e7891195ff2cde8/1jb5521t8";
      script.charset = "UTF-8";
      script.setAttribute("crossorigin", "*");

      document.body.appendChild(script);

      removeInteractionListeners();

      if (fallbackTimer) {
        clearTimeout(fallbackTimer);
      }
    };

    const removeInteractionListeners = () => {
      window.removeEventListener("scroll", loadTawk);
      window.removeEventListener("pointerdown", loadTawk);
      window.removeEventListener("keydown", loadTawk);
    };

    // Load chatbot as soon as the visitor actually interacts.
    window.addEventListener("scroll", loadTawk, {
      once: true,
      passive: true,
    });

    window.addEventListener("pointerdown", loadTawk, {
      once: true,
      passive: true,
    });

    window.addEventListener("keydown", loadTawk, {
      once: true,
    });

    // Fallback:
    // If visitor doesn't interact, load chat later.
    fallbackTimer = window.setTimeout(() => {
      loadTawk();
    }, 20000);

    return () => {
      removeInteractionListeners();

      if (fallbackTimer) {
        clearTimeout(fallbackTimer);
      }
    };
  }, [location]);


  // useEffect(() => {
  //   // detect Chatbase messages
  //   window.addEventListener("message", (event) => {
  //     if (!event.data) return;

  //     const msg = String(event.data).toLowerCase();

  //     // keywords that trigger human chat
  //     const openHuman = [
  //       "human",
  //       "support",
  //       "help",
  //       "live agent",
  //       "talk to human",
  //       "real person",
  //       "operator",
  //       "contact",
  //     ];

  //     if (openHuman.some((k) => msg.includes(k))) {
  //       if (window.Tawk_API) {
  //         window.Tawk_API.maximize(); // open chat
  //       }
  //     }
  //   });
  // }, []);

  // Chatbase.co Chatbot
  // useEffect(() => {
  //   // Chatbase script loader function
  //   (function () {
  //     if (!window.chatbase || window.chatbase("getState") !== "initialized") {
  //       window.chatbase = (...arguments_) => {
  //         if (!window.chatbase.q) {
  //           window.chatbase.q = [];
  //         }
  //         window.chatbase.q.push(arguments_);
  //       };
  //       window.chatbase = new Proxy(window.chatbase, {
  //         get(target, prop) {
  //           if (prop === "q") {
  //             return target.q;
  //           }
  //           return (...args) => target(prop, ...args);
  //         },
  //       });
  //     }
  //     const onLoad = function () {
  //       const script = document.createElement("script");
  //       script.src = "https://www.chatbase.co/embed.min.js";
  //       script.id = "Q6MtFizboIyXSo6PapuS5"; // <-- YOUR CHATBOT ID
  //       script.domain = "www.chatbase.co";
  //       document.body.appendChild(script);
  //     };

  //     if (document.readyState === "complete") {
  //       onLoad();
  //     } else {
  //       window.addEventListener("load", onLoad);
  //     }
  //   })();
  // }, []);

  return (
    <div>
      {/* <button
        onClick={() => window.Tawk_API?.maximize()}
        style={{
          position: "fixed",
          bottom: "20px",
          right: "100px",
          background: "#0077ff",
          color: "white",
          padding: "10px 15px",
          borderRadius: "8px",
          cursor: "pointer",
          zIndex: 9999,
        }}
      >
        Chat with Human Support
      </button> */}

      <div className="main-container">
        <Header props={props} />
        <main>
          {props.children}
        </main>
      </div>
      {faqData?.faqs?.length > 0 &&
        <FAQs faqData={faqData} />
      }
      <React.Suspense fallback={<></>}>
        <footer className={`footer-background ${location === '/services/' || location === '/technologies/' || location === '/auth/login/' || location.startsWith("/auth/admin") || location.startsWith("/auth/employee") || location.startsWith('/admin') ? 'd-none' : ''}`}>
          <ParticlesFooterBackground />
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 100" preserveAspectRatio="none">
            <path className="elementor-shape-fill" opacity="0.33" d="M473,67.3c-203.9,88.3-263.1-34-320.3,0C66,119.1,0,59.7,0,59.7V0h1000v59.7 c0,0-62.1,26.1-94.9,29.3c-32.8,3.3-62.8-12.3-75.8-22.1C806,49.6,745.3,8.7,694.9,4.7S492.4,59,473,67.3z"></path>
            <path className="elementor-shape-fill" opacity="0.66" d="M734,67.3c-45.5,0-77.2-23.2-129.1-39.1c-28.6-8.7-150.3-10.1-254,39.1 s-91.7-34.4-149.2,0C115.7,118.3,0,39.8,0,39.8V0h1000v36.5c0,0-28.2-18.5-92.1-18.5C810.2,18.1,775.7,67.3,734,67.3z"></path>
            <path className="elementor-shape-fill" d="M766.1,28.9c-200-57.5-266,65.5-395.1,19.5C242,1.8,242,5.4,184.8,20.6C128,35.8,132.3,44.9,89.9,52.5C28.6,63.7,0,0,0,0 h1000c0,0-9.9,40.9-83.6,48.1S829.6,47,766.1,28.9z"></path>
          </svg>
          {/* <div className='container'> */}
          <Footer />
          {/* </div> */}
        </footer>
      </React.Suspense>
    </div>
  )
}

export default Layout
